module.exports = __webpack_public_path__ + "media/images/mac_appstore_en-660dcb02.svg";